import React, { useState } from 'react'
import { Box, CircularProgress, Alert } from '@mui/material'
import { Section, ReportTable, SubTabs } from '../../report-shell'

const OrangeOpaskaRegionDistrict = ({ data, loading, error }) => {
  const [subTab, setSubTab] = useState(0)

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress />
      </Box>
    )
  }
  if (error) return <Alert severity="error">{error}</Alert>
  if (!data) return null

  const regionColumns = [
    { field: 'region', header: 'Region', width: '1.4fr', minWidth: 180 },
    { field: 'current_month', header: 'Bieżący miesiąc', width: '140px', sales: true },
    { field: 'prev_month', header: 'Poprzedni miesiąc', width: '140px', numeric: true },
    { field: 'total', header: 'Total', width: '110px', numeric: true },
  ]

  const regionServiceColumns = [
    { field: 'Region', header: 'Region', width: '1.2fr', minWidth: 150 },
    { field: 'z_usluga_current',     header: 'Z usługą — bież.',   width: '140px', sales: true },
    { field: 'bez_uslugi_current',   header: 'Bez usługi — bież.', width: '150px', sales: true },
    { field: 'total_current',        header: 'TOTAL — bież.',      width: '130px', sales: true },
    { field: 'z_usluga_prev',        header: 'Z usługą — poprz.',  width: '140px', numeric: true },
    { field: 'bez_uslugi_prev',      header: 'Bez usługi — poprz.', width: '150px', numeric: true },
    { field: 'total_prev',           header: 'TOTAL — poprz.',     width: '130px', numeric: true },
  ]

  const districtColumns = [
    { field: 'district', header: 'Dystrykt', width: '1.4fr', minWidth: 180 },
    { field: 'region',   header: 'Region',   width: '160px' },
    { field: 'current_month', header: 'Bieżący miesiąc',   width: '140px', sales: true },
    { field: 'prev_month',    header: 'Poprzedni miesiąc', width: '140px', numeric: true },
    { field: 'total',         header: 'Total',             width: '110px', numeric: true },
  ]

  const districtServiceColumns = [
    { field: 'Dystrykt', header: 'Dystrykt', width: '1.2fr', minWidth: 150 },
    { field: 'Region',   header: 'Region',   width: '140px' },
    { field: 'z_usluga_current',   header: 'Z usługą — bież.',   width: '140px', sales: true },
    { field: 'bez_uslugi_current', header: 'Bez usługi — bież.', width: '150px', sales: true },
    { field: 'total_current',      header: 'TOTAL — bież.',      width: '130px', sales: true },
    { field: 'z_usluga_prev',      header: 'Z usługą — poprz.',  width: '140px', numeric: true },
    { field: 'bez_uslugi_prev',    header: 'Bez usługi — poprz.', width: '150px', numeric: true },
    { field: 'total_prev',         header: 'TOTAL — poprz.',     width: '130px', numeric: true },
    { field: 'total_all',          header: 'Total',              width: '100px', numeric: true },
  ]

  const kamColumns = [
    { field: 'kam', header: 'KAM', width: '1.2fr', minWidth: 140 },
    { field: 'last_day',      header: 'Ostatni dzień',    width: '120px', sales: true },
    { field: 'current_month', header: 'Bieżący miesiąc',  width: '140px', sales: true },
    { field: 'prev_month',    header: 'Poprzedni miesiąc', width: '140px', numeric: true },
    { field: 'total',         header: 'Total',            width: '110px', numeric: true },
  ]

  const tabs = [
    { label: 'Regiony',               rows: (data.by_region || []).map((r, i) => ({ id: i, ...r })),         columns: regionColumns,         sortField: 'total' },
    { label: 'Regiony (z usługą)',    rows: (data.by_region_service || []).map((r, i) => ({ id: i, ...r })), columns: regionServiceColumns,  sortField: 'total_current' },
    { label: 'Dystrykty',             rows: (data.by_district || []).map((r, i) => ({ id: i, ...r })),       columns: districtColumns,       sortField: 'total' },
    { label: 'Dystrykty (z usługą)',  rows: (data.by_district_service || []).map((r, i) => ({ id: i, ...r })), columns: districtServiceColumns, sortField: 'total_all' },
    { label: 'Per KAM',               rows: (data.by_kam || []).map((r, i) => ({ id: i, ...r })),            columns: kamColumns,            sortField: 'total' },
  ]
  const active = tabs[subTab]

  return (
    <Section
      title="Regiony i dystrykty"
      right={<SubTabs tabs={tabs.map(t => t.label)} value={subTab} onChange={setSubTab} />}
    >
      <ReportTable
        rows={active.rows}
        columns={active.columns}
        initialSort={{ field: active.sortField, dir: 'desc' }}
        pageSize={25}
        pageSizeOptions={[25, 50]}
        density="compact"
        totals={subTab === 0 || subTab === 2}
      />
    </Section>
  )
}

export default OrangeOpaskaRegionDistrict
